<div class="wrap">
  <div class="validation">
    <div class="validation_mail">
      <div class="check">
        <span class="icon-line line-tip"></span>
        <span class="icon-line line-long"></span>
        <div class="icon-circle"></div>
        <div class="icon-fix"></div>
      </div>
    </div>
    <p>Votre demande de lier votre compte avec votre licence a bien été prise en compte</p>
    <p>Un mail de confirmation vous a été envoyé.</p>
    <p>Veuillez confirmer ce dernier pour profiter de vos infos FFVoile. </p>
    <!-- <p class="redirection">Redirection en cours <span>.</span><span>.</span><span>.</span> </p> -->
  </div>
</div>
